export const paranoidModeQueryKey = ["getParanoidModeConfig"];
export const paranoidModeMutationKey = ["postParanoidModeConfig"];
